function submitForm(formElement, submitter) {
    const submitButton = submitter || formElement.querySelector('[type="submit"]');

    fetch(formElement.action, {
        cache: 'no-cache',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(formElement, submitButton),
        method: 'POST',
    })
        .then((response) => {
            if (response.status === 422) {
                return response.text();
            }

            if (response.status === 201 && response.headers.has('Location')) {
                window.location.href = new URL(response.headers.get('Location'), window.location.origin).toString();
                return;
            }

            if (response.status === 200) {
                window.location.reload();
                return;
            }

            throw new Error('Something went wrong');
        })
        .then((response) => {
            // Form error
            updateFormContent(response, formElement);
        })
        .catch((error) => {
            console.log(error);
        });
}

function updateFormContent(response, form) {
    const parser = new DOMParser();
    const htmlResponse = parser.parseFromString(response, 'text/html');
    const formResponse = htmlResponse.querySelector(`#${form.id}`);

    if (formResponse !== null) {
        form.innerHTML = formResponse.innerHTML;
    }
}

for (const form of document.querySelectorAll('[data-form-submit-ajax]')) {
    form.addEventListener('submit', function (e) {
        e.preventDefault();

        submitForm(this, e.submitter);
    });
}
